import React, { createContext, useEffect, useState, useCallback } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initAuth = () => {
      try {
        const token = localStorage.getItem('authToken');
        const storedUser = localStorage.getItem('user');

        if (token && storedUser && storedUser !== 'undefined') {
          const parsedUser = JSON.parse(storedUser);
          // Todos os papéis internos. A lista estava desactualizada e só
          // reconhecia admin, super_admin e supervisor: quem tivesse um dos
          // papéis criados depois (operações, terreno, avaliação) era posto
          // fora a cada recarregamento da página, mesmo com sessão válida.
          // Não se via a navegar dentro da aplicação — só ao actualizar ou ao
          // abrir um endereço directo.
          const STAFF = [
            'admin', 'super_admin', 'supervisor',
            'operations_manager', 'field_agent', 'technical_surveyor', 'inspector',
          ];
          if (STAFF.includes(parsedUser.role) || parsedUser.user_type === 'admin') {
            setUser(parsedUser);
            setIsAuthenticated(true);
          } else {
            // Não é staff, limpar
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
          }
        }
      } catch (error) {
        console.error('Failed to parse stored user:', error);
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
      } finally {
        setIsLoading(false);
      }
    };

    initAuth();
  }, []);

  const login = useCallback((userData) => {
    if (!userData || typeof userData !== 'object') {
      console.warn("Invalid userData passed to login", userData);
      return false;
    }

    localStorage.setItem('authToken', userData.token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    setIsAuthenticated(true);
    return true;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setUser(null);
    setIsAuthenticated(false);
  }, []);

  const updateUser = useCallback((newUserData) => {
    setUser(prev => {
      const updated = { ...prev, ...newUserData };
      localStorage.setItem('user', JSON.stringify(updated));
      return updated;
    });
  }, []);

  const getToken = useCallback(() => {
    return localStorage.getItem('authToken');
  }, []);

  return (
    <AuthContext.Provider value={{ 
      isAuthenticated, 
      isLoading,
      login, 
      logout, 
      user, 
      updateUser,
      getToken 
    }}>
      {children}
    </AuthContext.Provider>
  );
};
